import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface DialogData {
  images: Array<any>
}

@Component({
  selector: 'app-edit-property-images',
  templateUrl: './edit-property-images.component.html',
  styleUrls: ['./edit-property-images.component.css']
})
export class EditPropertyImagesComponent{

  galleryImages = []

  galleryImagesPhotoPaths = []

  showError: boolean

  constructor(
    public dialogRef: MatDialogRef<EditPropertyImagesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private notification: MatSnackBar) {

    }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onGalleryImageChange($event){
    // this.data.images = []
    // this.galleryImagesPhotoPaths = []
    let images = $event.target.files
    let validImages = []
    if(images.length > 0){
      for(let image of images){
        var filesize = Math.ceil((parseInt(image.size)/1024)/1024)
        if(filesize <= 8){
          var reader = new FileReader()
          reader.readAsDataURL(image)
          var blob = image.slice(0, image.size, 'image/png'); 
          let name = image.name
          let newImage = new File([blob], name.replace(/[^A-Z0-9.]/ig+ ""), {type: 'image/png'});
          validImages.push(newImage)
          reader.onload = (_event) => { 
            this.galleryImagesPhotoPaths.push({ name: image.name, imagePath: _event.target.result})
          }
        }else{
          this.openNotification('Image size cannot exceed 2Mb')
        }
      }
    }
    this.data.images = this.data.images.concat(validImages)
  }

  removeFromGallery(name){
    let previewIndex = this.galleryImagesPhotoPaths.indexOf(this.galleryImagesPhotoPaths.find(image => image.name == name))
    this.galleryImagesPhotoPaths.splice(previewIndex, 1)
    let galleryIndex = this.galleryImages.indexOf(this.galleryImages.find(image => image.name == name))
    let dataImagesIndex = this.data.images.indexOf(this.data.images.find(image => image.name == name))
    this.galleryImages.splice(galleryIndex, 1)
    this.data.images.splice(dataImagesIndex, 1)
  }

  openNotification(msg){
    this.notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  savePropertyBasicInfo(){
    this.dialogRef.close(this.data)
  }

}
